import { QuoteAutoReplyScope } from 'clerk_common/types';

export function formatQuoteAutoReplyScopeForSimulationTrail(
  scope: string
): 'draft' | 'reply' | 'launch agent' | 'disabled' {
  switch (scope as QuoteAutoReplyScope) {
    case QuoteAutoReplyScope.DRAFT:
      return 'draft';
    case QuoteAutoReplyScope.SEND:
      return 'reply';
    case QuoteAutoReplyScope.AGENT:
      return 'launch agent';
    case QuoteAutoReplyScope.DISABLED:
    default:
      return 'disabled';
  }
}

function getSimulationRunOutcomePhrase(
  wouldAutoRespond: boolean,
  scope: QuoteAutoReplyScope
): string {
  if (wouldAutoRespond) {
    switch (scope) {
      case QuoteAutoReplyScope.DRAFT:
        return 'would auto draft';
      case QuoteAutoReplyScope.AGENT:
        return 'would launch agent';
      case QuoteAutoReplyScope.SEND:
      case QuoteAutoReplyScope.DISABLED:
      default:
        return 'would auto reply';
    }
  }
  switch (scope) {
    case QuoteAutoReplyScope.DRAFT:
      return 'would not auto draft';
    case QuoteAutoReplyScope.AGENT:
      return 'would not launch agent';
    case QuoteAutoReplyScope.SEND:
    case QuoteAutoReplyScope.DISABLED:
    default:
      return 'would not auto reply';
  }
}

export function getSimulationRunQuoteTrailMessage(meta: {
  wouldAutoRespond: boolean;
  autoReplyScope: string;
  stepCount: number;
}): string {
  const scopeEnum = Object.values(QuoteAutoReplyScope).includes(
    meta.autoReplyScope as QuoteAutoReplyScope
  )
    ? (meta.autoReplyScope as QuoteAutoReplyScope)
    : QuoteAutoReplyScope.DISABLED;
  const scopeLabel = formatQuoteAutoReplyScopeForSimulationTrail(
    meta.autoReplyScope
  );
  const outcome = getSimulationRunOutcomePhrase(
    meta.wouldAutoRespond,
    scopeEnum
  );
  return `Quote job reply simulation: ${outcome} (scope: ${scopeLabel}; ${meta.stepCount} step(s))`;
}
